
export default function ProblemSection() {
  const problems = [
    {
      icon: "ri-lock-line",
      color: "#E57373",
      title: "角度固定",
      desc: "用途別の最適角度に非対応"
    },
    {
      icon: "ri-pencil-line",
      color: "#FFB74D",
      title: "ペン収納",
      desc: "落下リスク・見た目の問題"
    },
    {
      icon: "ri-question-line",
      color: "#9575CD",
      title: "根拠不明",
      desc: "医学的エビデンスなし"
    },
    {
      icon: "ri-contrast-line",
      color: "#4DB6AC",
      title: "二者択一",
      desc: "デザインか機能かの妥協"
    }
  ];

  return (
    <section id="problem" className="py-16 px-6 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-5xl mx-auto">
        {/* コンパクトなヘッダー */}
        <div className="text-center mb-10">
          <span className="text-xs tracking-widest text-gray-400 uppercase">Problem</span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mt-2" style={{ fontFamily: 'Playfair Display, serif' }}>
            既存製品の<span className="text-[#8B6BAE]">課題</span>
          </h2>
        </div>

        {/* インフォグラフィック風ビジュアル */}
        <div className="relative">
          {/* 中央のビジュアル */}
          <div className="flex flex-col lg:flex-row items-center gap-8">
            {/* 左側：問題アイコン群 */}
            <div className="flex-1 w-full">
              <div className="grid grid-cols-2 gap-3">
                {problems.map((problem, index) => (
                  <div 
                    key={index}
                    className="group relative bg-white rounded-xl p-4 border border-gray-100 hover:border-gray-200 hover:shadow-md transition-all cursor-default"
                  >
                    <div className="flex items-center gap-3">
                      <div 
                        className="w-10 h-10 flex items-center justify-center rounded-lg flex-shrink-0"
                        style={{ backgroundColor: `${problem.color}15` }}
                      >
                        <i className={`${problem.icon} text-lg`} style={{ color: problem.color }}></i>
                      </div>
                      <div className="min-w-0">
                        <h3 className="text-sm font-bold text-gray-900 whitespace-nowrap">{problem.title}</h3>
                        <p className="text-xs text-gray-500 leading-tight mt-0.5">{problem.desc}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* 中央：矢印とメッセージ */}
            <div className="flex flex-col items-center py-4 lg:py-0">
              <div className="hidden lg:flex flex-col items-center">
                <div className="w-px h-8 bg-gradient-to-b from-transparent to-gray-300"></div>
                <div className="w-12 h-12 flex items-center justify-center bg-[#8B6BAE] rounded-full shadow-lg">
                  <i className="ri-arrow-right-line text-xl text-white"></i>
                </div>
                <div className="w-px h-8 bg-gradient-to-b from-gray-300 to-transparent"></div>
              </div>
              <div className="lg:hidden flex items-center gap-2">
                <div className="w-8 h-px bg-gradient-to-r from-transparent to-gray-300"></div>
                <div className="w-10 h-10 flex items-center justify-center bg-[#8B6BAE] rounded-full shadow-lg">
                  <i className="ri-arrow-down-line text-lg text-white lg:hidden"></i>
                </div>
                <div className="w-8 h-px bg-gradient-to-r from-gray-300 to-transparent"></div>
              </div>
            </div>

            {/* 右側：解決イメージ */}
            <div className="flex-1 w-full">
              <div className="relative bg-gradient-to-br from-[#8B6BAE]/5 to-[#8B6BAE]/10 rounded-2xl p-6 border border-[#8B6BAE]/20">
                <div className="absolute -top-3 left-6">
                  <span className="px-3 py-1 bg-[#8B6BAE] text-white text-xs font-medium rounded-full">
                    Solution
                  </span>
                </div>
                <div className="flex items-center gap-4 mt-2">
                  <div className="w-16 h-16 flex items-center justify-center bg-white rounded-xl shadow-sm flex-shrink-0">
                    <i className="ri-check-double-line text-3xl text-[#8B6BAE]"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-1">Atelier Folio</h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      医学的根拠に基づく角度設計と<br className="hidden sm:block" />
                      洗練されたデザインの両立
                    </p>
                  </div>
                </div>
                {/* 解決ポイント */}
                <div className="mt-4 grid grid-cols-2 gap-2">
                  <div className="flex items-center gap-2 text-xs text-gray-600">
                    <i className="ri-checkbox-circle-fill text-[#6B9B8A]"></i>
                    <span>3段階角度調整</span>
                  </div>
                  <div className="flex items-center gap-2 text-xs text-gray-600">
                    <i className="ri-checkbox-circle-fill text-[#6B9B8A]"></i>
                    <span>ペン収納内蔵</span>
                  </div>
                  <div className="flex items-center gap-2 text-xs text-gray-600">
                    <i className="ri-checkbox-circle-fill text-[#6B9B8A]"></i>
                    <span>人間工学設計</span>
                  </div>
                  <div className="flex items-center gap-2 text-xs text-gray-600">
                    <i className="ri-checkbox-circle-fill text-[#6B9B8A]"></i>
                    <span>ミニマルデザイン</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
